import {
  amountValidation,
  Box,
  BoxProps,
  Button,
  ColorOptions,
  Loader,
  ModBox,
  Spacer,
  Text,
  TextInput,
  TextProps,
} from '@jfs/ui-new'
import { useEffect, useRef, useState } from 'react'
import { AppState, InteractionManager, Keyboard, Platform } from 'react-native'
import { useKeyboard } from '../../comps/KeyboardAwareModal/keyboardHook'
import { SvgImage } from '../../comps/SvgImage'
import { logEvent, testProps } from '../../util/util'
import { InternalTextInput } from './InternalTextInput'

interface KeyboardAwareModalInterface {
  visible: boolean
  hideModal: () => void
  totalAmount?: string | number
  state?: 'pending' | 'fulfilled' | 'rejected' | undefined
  handleGenerateQr: (amount: string) => void
  generateStatus?: boolean
  amount: string
}

export const formData = (amount: any): any => [
  {
    formItems: [
      {
        fieldName: 'amount',
        ComponentName: InternalTextInput,
        editable: true,
        validationSchema: amountValidation,
        inputMode: 'numeric',
        autoFocus: true,
        leftComponent: <Rupee amount={amount} />,
        fontFamily: 'JioType-Bold',
        fontSize: 24,
        height: 60,
        placeholder: 'Enter Amount',
        ...testProps('qr-input-button'),
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]

const QrInput = ({ visible, hideModal, handleGenerateQr, state, amount }: KeyboardAwareModalInterface) => {
  const [keyboardHeight] = useKeyboard()
  const [statusBarHeight, setStatusbarHeight] = useState(0)
  const [amt, setAmt]: any = useState('')
  const [error, setError]: any = useState('')
  const [isValid, setIsValid]: any = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      inputRef.current.focus()
    })
  }, [])
  useEffect(() => {
    if (error?.length > 0) {
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }, [error])

  useEffect(() => {
    if (Platform.OS === 'ios') {
      const handleAppStateChange = (nextAppState) => {
        if (nextAppState === 'inactive' || nextAppState === 'background') {
          // App is going to background or inactive (e.g., screen locked)
          Keyboard.dismiss()
        }
      }

      const subscription = AppState.addEventListener('change', handleAppStateChange)

      return () => {
        subscription.remove() // Clean up the listener
      }
    }
  }, [])

  const validateAmount = (text: any) => {
    setAmt(text)
    const reg = /^\d+(\.\d{1,2})?$/
    setIsValid(true)
    if (text?.length === 0) {
      setError('Please enter a number.')
      setIsValid(false)
    } else if (!text.match(reg)) {
      setError('Please enter correct amount.')
      setIsValid(false)
    }
  }

  const generateQr = () => {
    logEvent('btn_press', 'generate_qr')
    const reg = /^\d+(\.\d{1,2})?$/
    setIsValid(true)
    if (amt.match(reg)) {
      handleGenerateQr(amt)
    } else {
      setIsValid(false)
      setError('Please enter correct amount.')
      // show error message
    }
  }

  return (
    <ModBox
      position={'absolute'}
      show={visible}
      width={'100%'}
      bottom={0}
      borderTopLeftRadius={35}
      borderTopRightRadius={35}
      overflowY="hidden"
      zIndex={10}
      backgroundColor={'WHITE'}>
      <Box {...styles.boxWrapper(keyboardHeight, statusBarHeight)}>
        <Box {...styles.closeIcon} onPress={hideModal} {...testProps('close-qr-button')} underlayColor={'TRANSPARENT'}>
          {/* <Icon id={'CLOSE'} size={20} color={'BLACK'} /> */}
          <SvgImage imageName="Close" />
        </Box>
        <Box marginHorizontal={15} mt={30}>
          <Box borderWidth={1} borderRadius={8} borderColor={'PRIMARY'} paddingHorizontal={10}>
            <TextInput
              placeholder="Enter Amount"
              minHeight={60}
              keyboardType="numeric"
              bottomLineColor="TRANSPARENT"
              onFocus={() => setError('')}
              showBottomLine={false}
              innerRef={inputRef}
              onChangeText={validateAmount}
              fontFamily={'JioType-Black'}
              fontSize={24}
              placeholderTextColor={'#b9b9b9' as ColorOptions}
              leftComponent={<Rupee amount={amt} />}
              selectionColor={'PRIMARY'}
              fontWeight={'BLACK'}
              maxLength={10}
              returnKeyType="done"
            />
          </Box>
          <Text fontFamily="JioType-Medium" color={'#ED617F' as ColorOptions} fontSize={12}>
            {error}
          </Text>
          <Spacer direction="vertical" size={10} />
          <Button
            isFull
            isRound
            height={50}
            isLoading={state === 'pending'}
            disabled={state === 'pending' || !isValid}
            type={'primary'}
            {...testProps('generate-qr-button')}
            onPress={generateQr}>
            {state === 'pending' ? (
              <Loader type={'small'} color="WHITE" />
            ) : (
              <Text color={'WHITE'} fontFamily="JioType-Bold" fontSize={16}>
                Generate QR
              </Text>
            )}
          </Button>
        </Box>
        {/* <Box {...styles.containerView}>
          <Form initialValues={{ amount: amount }} formData={formData(amount)} actionButtons={renderActionButtons} />
        </Box> */}
      </Box>
    </ModBox>
  )
}

const styles = {
  closeIcon: {
    alignSelf: 'flex-end',
    marginRight: 15,
  } as BoxProps,
  boxWrapper: (keyboardHeight: number, statusBarHeight: number) =>
    ({
      backgroundColor: 'WHITE',
      marginBottom: statusBarHeight > 30 ? keyboardHeight - statusBarHeight : keyboardHeight,
      borderTopLeftRadius: 35,
      borderTopRightRadius: 35,
      paddingHorizontal: 15,
      paddingTop: 30,
      paddingBottom: 36,
    } as BoxProps),
  containerView: {
    width: '100%',
    minHeight: 180,
  } as BoxProps,
  leftRupeeText: (amt: any) =>
    ({
      fontSize: 24,
      fontFamily: 'JioType-Black',
      color: amt?.length ? 'BLACK' : '#b9b9b9',
    } as TextProps),
}
const Rupee = (amt: any) => {
  const amount = amt?.amount
  return (
    <>
      <Text {...styles.leftRupeeText(amount)}>{'₹ '}</Text>
    </>
  )
}

export { QrInput }
